/**
 * Copy for the runtime's `409 featured_source` answer: a content item cannot
 * be hidden while a featured slide opens it (`details.slides: [{ id, title }]`).
 * @param {Array<{ id?: number, title?: string }>} slides
 * @param {string} [itemTitle] names the item instead of "This item" (bulk edits)
 */
export function featuredSourceMessage(slides, itemTitle) {
	const titles = (slides || []).map((s) => (s && s.title ? String(s.title) : '')).filter(Boolean)
	const subject = itemTitle ? `“${itemTitle}”` : 'This item'
	if (titles.length > 1) {
		return `${subject} is the source of featured slides ${titles.map((t) => `“${t}”`).join(', ')}. Remove the slides or choose another item first.`
	}
	const slide = titles.length ? `featured slide “${titles[0]}”` : 'a featured slide'
	return `${subject} is the source of ${slide}. Remove the slide or choose another item first.`
}

/** True when the slide's source content is hidden on the site (the slide is not rendered). */
export function slideSourceHidden(slide, content = []) {
	const source = content.find((c) => String(c.id) === String(slide?.contentId))
	if (source) return source.published === false
	return slide?.content?.published === false
}
